import { Injectable } from "@angular/core";
import { BaseStyle } from "primeng/base";
import { Ankaadia } from "../../../theme/preset";

@Injectable({ providedIn: "root" })
export class SidenavContentStyle extends BaseStyle {
  override name = "sidenavcontent";

  override theme = ({ dt }: any): string => `
    .ui-sidenavcontent {
      display: flex;
      flex-direction: column;
      height: 100%;
      position: absolute;
      inset-block-start: 0;
      inset-inline-start: 100%;
      background: ${dt("sidenav.background.right")};
      color: ${dt("sidenav.color")};
      overflow-x: hidden;
      overflow-y: auto;
      width: 0;
      transition: width ${dt("transition.duration")} ${dt("transition.easing")};
    }

    .ui-sidenavcontent-panel {
      display: flex;
      flex-direction: column;
      flex: auto;
      width: max-content;
      min-width: ${dt("sidenav.panel.min.width")};
      gap: ${dt("sidenav.panel.gap")};
      padding: ${dt("sidenav.panel.padding")};
      border-inline-end-width: ${dt("sidenav.separator.width")};
      border-inline-end-color: ${dt("sidenav.separator.color")};
    }

    .ui-sidenavcontent-list {
      display: flex;
      flex: auto;
      flex-direction: column;
      gap: ${dt("sidenav.list.gap")};
    }

    @media (width < ${Ankaadia.semantic.breakpoint.mobile}) {
      .ui-sidenavcontent {
        position: fixed;
        inset-inline-start: 0;
        inset-block-end: calc(${dt("sidenav.panel.mobile.height")} + env(safe-area-inset-bottom, 0px));
        height: auto;
      }

      .ui-sidenavcontent.ui-sidenavcontent-active {
        width: 100% !important;
      }

      .ui-sidenavcontent-panel {
        border-inline-end-width: 0;
        width: 100%;
      }
    }
  `;

  override classes = {
    root: ({ instance }: any): Record<string, boolean> => ({
      "ui-sidenavcontent": true,
      "ui-sidenavcontent-active": instance.active(),
    }),
    panel: "ui-sidenavcontent-panel",
    list: "ui-sidenavcontent-list",
  };
}
